type sizestring = 'micro' | 'small' | 'large';
export type fillstring = 'white' | 'green' | 'gray';
export interface LoadingProps {
	fill: fillstring;
	size: sizestring;
}

interface HeightWidth {
	height: number;
	width: number;
}
const getHeightAndWidth = (size: sizestring): HeightWidth => {
	switch (size) {
		case 'large':
			return { height: 100, width: 70 };
		case 'small':
			return { height: 25, width: 17 };
		case 'micro':
			return { height: 16, width: 15 };
	}
};

const getFillColor = (fill: fillstring): string => {
	switch (fill) {
		case 'white':
			return '#fff';
		case 'green':
			return 'green';
		case 'gray':
			return '#54585A';
	}
};

export const Loading: React.FC<LoadingProps> = (props: LoadingProps) => {
	const hw = getHeightAndWidth(props.size);
	const fill = getFillColor(props.fill);
	return (
		<svg
			id="L5"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			height={hw.height}
			width={hw.width}
			viewBox="0 0 70 100"
			preserveAspectRatio="xMaxYMax meet"
			enableBackground="new 0 0 0 0"
			xmlSpace="preserve"
		>
			<circle fill={fill} stroke="none" cx="6" cy="50" r="6">
				<animateTransform
					attributeName="transform"
					dur="1s"
					type="translate"
					values="0 15 ; 0 -15; 0 15"
					repeatCount="indefinite"
					begin="0.1"
				/>
			</circle>
			<circle fill={fill} stroke="none" cx="30" cy="50" r="6">
				<animateTransform
					attributeName="transform"
					dur="1s"
					type="translate"
					values="0 10 ; 0 -10; 0 10"
					repeatCount="indefinite"
					begin="0.2"
				/>
			</circle>
			<circle fill={fill} stroke="none" cx="54" cy="50" r="6">
				<animateTransform
					attributeName="transform"
					dur="1s"
					type="translate"
					values="0 5 ; 0 -5; 0 5"
					repeatCount="indefinite"
					begin="0.3"
				/>
			</circle>
		</svg>
	);
};
